import styled, { css } from 'styled-components';

import media from '~/utils/media';
import checkboxStd from '~/components/styled/checkbox';

export const Wrap = styled.div`
  > div.overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1001;
  }

  img.popup {
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const GoSignWrap = styled.div`
  background-color: #F2F2F2;
  position: relative;

  button.submit {
    width: 55%;
    height: 47%;
    background: transparent;
    border: none;
    position: absolute;
    top: 38.5%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const AgreeWrap = styled.div`
  padding: 4%;
  background-color: #F2F2F2;
`;

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  width: 100%;
  
  ${media.pcLarge`
    font-size: 20px;
  `}

  ${media.tabletLarge`
    font-size: 20px;
  `}

  ${media.tabletSmall`
    font-size: 20px;
  `}

  ${media.mobileLarge`
    font-size: 14px;
  `}

  ${media.mobileMid`
    font-size: 14px;
  `}

  ${media.mobileSmall`
    font-size: 14px;
  `}

  font-weight: 700;
  color: #434343;
  letter-spacing: -1px;

  > svg {
    margin-left: 2%;

    ${({ isCheck }) => isCheck ? css`
      transform: rotate(-180deg);
      transition: transform 150ms ease;
    ` : css`
      transform: rotate(0deg);
      transition: transform 150ms ease;
    `}

    ${media.mobileSmall`
      width: 32px;
      height: 32px;
    `}

    ${media.pcLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletSmall`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileLarge`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileMid`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileSmall`
      width: 20px;
      height: 20px;
    `}
  }
`;

export const Checkbox = styled.input`
  ${checkboxStd};

  ${media.mobileSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.pcLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.mobileLarge`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileMid`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileSmall`
    width: 20px;
    height: 20px;
  `}

  margin-right: 2%;
`;

export const Ul = styled.ul`
  margin-top: 2%;

  > li {
    padding-left: 2%;

    ${media.pcLarge`
      font-size: 16px;
    `}

    ${media.tabletLarge`
      font-size: 16px;
    `}

    ${media.tabletSmall`
      font-size: 16px;
    `}

    ${media.mobileLarge`
      font-size: 12px;
    `}

    ${media.mobileMid`
      font-size: 12px;
    `}

    ${media.mobileSmall`
      font-size: 12px;
    `}

    ${media.pcLarge`
      line-height: 28px;
    `}

    ${media.tabletLarge`
      line-height: 28px;
    `}

    ${media.tabletSmall`
      line-height: 28px;
    `}

    ${media.mobileLarge`
      line-height: 20px;
    `}

    ${media.mobileMid`
      line-height: 20px;
    `}

    ${media.mobileSmall`
      line-height: 20px;
    `}

    color: #656565;
    letter-spacing: -1px;
  }
`;

export const QuizWrap = styled.div`
  background-color: #f2f2f2;
  position: relative;

  img.question {
    width: 100%;
    position: absolute;
    top: 4%;
  }
  
  > div.answer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    position: absolute;
    top: 72%;
    left: 50%;
    transform: translateX(-50%);

    > img {
      width: 20%;
      cursor: pointer;
    }
  }

  > img.submit {
    width: 60%;
    position: absolute;
    bottom: 4.5%;
    left: 50%;
    transform: translateX(-50%);
  }
`;
